// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"08a3d49c","407":"d8ccff0e","746":"d790c52e","968":"f19e39be"}[chunkId] + ".chunk.js";
};